<template>
    <div class="nav-main">
        <ul class="list-unstyled nav">
            <li v-for="item in setup.main_page_navigation" class="parent-link" :data-href="item.href" @mouseover="initMenuOverlay(item.dropdown)" @mouseleave="disMenuOverlay">
                <router-link :to="item.href" @click.native="startLoader(item.href)">
                    {{item.name}}
                    <navDrop v-if="item.dropdown == 'true'" :drop_key="item.href"></navDrop>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import navDrop from '@/components/nav-main/nav-drop.vue'
    export default {
        name: 'nav-main',
        components: {
            navDrop,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        methods: {
            startLoader(href) {
                const nameOfLink = href.replace(/\#.*/,'').replace('/', '');
                if (href != '/partners') {
                    // console.log(nameOfLink, this.routerName)
                    if (nameOfLink != this.routerName) {
                        this.$parent.$parent.$refs.topProgress.start();
                    }
                }
            },
            initMenuOverlay(param) {
                // console.log('ohh its works', 'asdasdasdasd');
                if (param == 'true') {
                    this.$store.commit('Open_form_Consult', true);
                }
            },
            disMenuOverlay() {
                // console.log('disable menu', 'asdasdasdasd')
                this.$store.commit('Open_form_Consult', false);
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/nav-main.scss';
</style>